import palette from './palette';

const customShadows = {
  z1: `0px 1px 2px 0px ${palette.transparent.black[12]}`,
  z8: `0px 8px 16px 0px ${palette.transparent.black[12]}`,
  z12: `0px 12px 24px -4px ${palette.transparent.black[12]}`,
  z16: `0px 16px 32px -4px ${palette.transparent.black[12]}`,
  z20: `0px 20px 40px -4px ${palette.transparent.black[12]}`,
  z24: `0px 24px 48px 0px ${palette.transparent.black[12]}`,
  //
  primary: `0px 8px 16px 0px ${palette.transparent.primary[24]}`,
  info: `0px 8px 16px 0px ${palette.transparent.info[24]}`,
  secondary: `0px 8px 16px 0px ${palette.transparent.secondary[24]}`,
  success: `0px 8px 16px 0px ${palette.transparent.success[24]}`,
  warning: `0px 8px 16px 0px ${palette.transparent.warning[24]}`,
  error: `0px 8px 16px 0px ${palette.transparent.error[24]}`
} as const;

export default customShadows;
